import axios from 'axios';

const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:3000';

const api = axios.create({
  baseURL: API_URL,
  timeout: 15000,
});

// Auto-logout when a request gets a 401 -- except signing in and switching
// user, where a 401 is a wrong password or PIN, said on the form (3 Nov 2026:
// a wrong PIN used to sign the person holding the device out).
const WRONG_CODE = /\/auth\/(login|switch)$/;

api.interceptors.response.use(
  res => res,
  err => {
    if (err.response?.status === 401 && !WRONG_CODE.test(err.config?.url || '')) {
      const hadToken = !!localStorage.getItem('mouldos_token');
      localStorage.removeItem('mouldos_token');
      localStorage.removeItem('mouldos_user');
      delete api.defaults.headers.common['Authorization'];
      if (hadToken) sessionStorage.setItem('session_expired', '1');
      window.location.href = '/';
    }
    return Promise.reject(err);
  }
);

export default api;
